"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectABTestVariant = exports.flowPathVisitNodes = void 0;
function flowPathVisitNodes(props) {
    const { path, visitor, context } = props;
    let ctx = context;
    path.forEach((node) => {
        ctx = visitor(node, ctx);
        if (node.type === 'condNode') {
            node.paths.forEach((p) => flowPathVisitNodes({ ...props, context: ctx, path: p.path }));
        }
    });
}
exports.flowPathVisitNodes = flowPathVisitNodes;
function selectABTestVariant(path, abTest, abTestVariant) {
    return path
        .map((node) => {
        if (node.type === 'abTestNode' && node.name === abTest) {
            const splitPath = node.paths.find((p) => p.name === abTestVariant);
            if (!splitPath)
                throw new Error(`AB Test ${abTest}  with variant ${abTestVariant} not found`);
            return splitPath.path;
        }
        if (node.type === 'abTestNode' || node.type === 'condNode') {
            return {
                ...node,
                paths: node.paths.map((splitPath) => ({
                    ...splitPath,
                    path: selectABTestVariant(path, abTest, abTestVariant),
                })),
            };
        }
        return node;
    })
        .flat();
}
exports.selectABTestVariant = selectABTestVariant;
//# sourceMappingURL=flow-path-xstate-helpers.js.map